import React, { useState, useEffect } from 'react';
import useStateRef from "react-usestateref";
import './styles/registered_tga_approval_style.css';
import './styles/index.css';
import EventEmitter from 'src/utils/EventEmitter';
// import axios from 'axios';
// import { CloseSnackbarAction } from 'src/components/CloseSnackbarAction';
// import { CheckExpiredToken } from 'src/components/CheckeExpiredToken';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import Enumerable from 'linq';
import CloseIcon from '@mui/icons-material/Close';
import { LoadingView } from 'src/components/LoadingView';
import { FormControl } from "native-base";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {
  makeStyles, MenuItem, Menu
} from '@material-ui/core';
import ArrowDropUpRoundedIcon from '@mui/icons-material/ArrowDropUpRounded';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const useStyles = makeStyles(theme => ({
  searchbox: {
    width: '627px',
    height: '40px',
    borderRadius: '4px',
    border: '1px solid #DEE5EF',
    padding: '13.25px',
    fontSize: '14px',
  },
  select_menu: {
    fontFamily: "Inter !important",
    marginTop: "3px",
    '& li': {
      fontSize: "14px",
      color: "#394A64",
      padding: "12px 16px",
      lineHeight: "19.6px",
      fontFamily: "Inter !important",
    },
    '& ul.MuiMenu-list': {
      padding: "0px"
    },
    '& .MuiPaper-root': {
      borderRadius: "4px",
      overflowY: "overlay"
    }
  },
  select_menu_sort: {
    '& .MuiPaper-root': {
      width: '250px'
    }
  },
  searchbox_menu: {
    width: '100%',
    minWidth: '169px',
    height: '40px',
    borderRadius: '4px',
    border: '1px solid #B7C0C6',
    padding: '13.25px',
    fontSize: '14px',
    color: '#202020',
    fontWeight: '400',
    letterSpacing: '-0.02em',
    "& input::placeholder": {
      color: '#909AA4',
      fontWeight: '500',
    }
  },
}));

const RegisteredTGAApprovalsView = (props) => {
  /* eslint-disable */
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading, loadingRef] = useStateRef(false);
  const [productList, setProductList, productListRef] = useStateRef([]);
  const [prescribersData, setPrescribersData, prescribersDataRef] = useStateRef(props.customData.PrescriberData);
  const [selectedDoseFormat, setSelectedDoseFormat, selectedDoseFormatRef] = useStateRef('Dose Format');
  const [anchorSelectMenuDoseFormat, setAnchorSelectMenuDoseFormat] = useState(null);
  const openSelectMenuDoseFormat = Boolean(anchorSelectMenuDoseFormat);
  const [optionsDoseFormat, setOptionsDoseFormat, optionsDoseFormatRef] = useStateRef([]);

  const defaultSortData = {
    Category: { sort: "asc", key: "Category" },
    Status: { sort: "asc", key: "Status" },
    ExpiryDate: { sort: "asc", key: "ExpiryDate" },
    Approval: { sort: "asc", key: "Approval" }
  }

  const [selectedSort, setSelectedSort, selectedSortRef] = useStateRef("Category");
  const [sortData, setSortData, sortDataRef] = useStateRef(defaultSortData);

  let headerData = [
    // { id: "Patient", name: "Patient", width_table: 12 },
    { id: "Category", name: "Category", width_table: 13 },
    { id: "Status", name: "Status", width_table: 10 },
    { id: "ExpiryDate", name: "Expiry Date", width_table: 15 },
    { id: "Approval", name: "Approval #", width_table: 25 },
    { id: "LicenseDocument", name: "License Document", width_table: 25 },
  ]

  if (selectedDoseFormatRef.current === 'SAS-B Approvals') {
    headerData = [
      { id: "Patient", name: "Patient", width_table: 12 },
      { id: "Category", name: "Category", width_table: 13 },
      { id: "Status", name: "Status", width_table: 10 },
      { id: "ExpiryDate", name: "Expiry Date", width_table: 15 },
      { id: "Approval", name: "Approval #", width_table: 25 },
      { id: "LicenseDocument", name: "License Document", width_table: 25 },
    ]
  }
  /* eslint-enable */

  /* eslint-disable react-hooks/exhaustive-deps*/
  useEffect(() => {
    if (!initialized) {
      setInitialized(true);
      // getDoseFormatList();
      const doseFormat = JSON.parse(localStorage.getItem('dose_format'));
      setOptionsDoseFormat(doseFormat);
    }
  }, []);

  // const getDoseFormatList = async () => {
  //   try {
  //     let token = localStorage.user_token ? JSON.parse(localStorage.user_token) : '';
  //     await axios.get(`/csapi/greenship/products/dose-format`,
  //       {
  //         headers: {
  //           "Authorization": `Bearer ${token}`,
  //         },
  //       }).then(async response => {
  //         if (response.data) {
  //           if (response.data.Data) {
  //             setOptionsDoseFormat(response.data.Data);
  //           }
  //         }
  //       })

  //     } catch (e) {
  //     var error_message = e.response ? e.response.data ? e.response.data.Message ? e.response.data.Message : e.response.data : e.response.statusText : e.message;

  //     var is_token_expired = CheckExpiredToken(error_message);

  //     if (!is_token_expired) {
  //       enqueueSnackbar(error_message, { variant: 'error', autoHideDuration: 2000, preventDuplicate: true, action: CloseSnackbarAction });
  //     }
  //   }
  // }

  const onClosePopup = () => {
    EventEmitter.emit("show_custom_popup", { value: false });
  }

  const onSubmit = () => {
    // EventEmitter.emit("show_custom_popup", { value: false });
  }

  const clickMenu = async (e) => {
    setAnchorSelectMenuDoseFormat(e.currentTarget);
  }

  const closeMenu = () => {
    setAnchorSelectMenuDoseFormat(null);
  }

  const onClickSelectedDoseFormat = async (value) => {
    setSelectedDoseFormat(value);
    closeMenu();
  }

  const clickSortData = async (value, type) => {
    if (value !== "LicenseDocument") {
      var new_sort_data = defaultSortData;
      var new_type = type === "asc" ? "desc" : "asc";
      /* eslint-disable */
      if (selectedSortRef.current != value) {
        new_type = "asc";
      }
      /* eslint-enable */
      new_sort_data[value].sort = new_type;

      setSortData(new_sort_data)
      setSelectedSort(value);
      sortByData(prescribersDataRef.current)
    }
  }

  const sortByData = (prescribers_data) => {
    var sort = "";
    var sort_data = "";
    if (selectedSortRef.current) {
      if (sortDataRef.current[selectedSortRef.current]) {
        sort_data = sortDataRef.current[selectedSortRef.current].sort;
        sort += sortDataRef.current[selectedSortRef.current].key;
      }
    }

    var new_list = prescribers_data;

    if (sort) {
      if (sort_data === "desc") {
        new_list = Enumerable.from(new_list)
          .orderByDescending(o => o[sort])
          .toArray();
      } else {
        new_list = Enumerable.from(new_list)
          .orderBy(o => o[sort])
          .toArray();
      }
    }

    setPrescribersData(new_list);

  }

  const getTableHeader = () => {
    var list = [];

    /* eslint-disable array-callback-return*/
    headerData.map((value, index) => {
      list.push(
        <div key={index} className="child" style={{ "--width": value.width_table + "%", cursor: value.id !== "LicenseDocument" ? "pointer" : "auto" }} onClick={() => clickSortData(value.id, sortDataRef.current[value.id] ? sortDataRef.current[value.id].sort : "")} >
          <div className="text">{value.name}</div>
          <div className="header-sort">
            {selectedSortRef.current === value.id && value.id !== "LicenseDocument" && selectedSortRef.current !== "Value" ?
              sortDataRef.current[value.id].sort === "desc" ?
                <ArrowDropUpRoundedIcon className={`sort-data top ${sortDataRef.current[value.id].sort === "desc" ? "selected" : ""}`} />
                :
                <ArrowDropDownRoundedIcon className={`sort-data bottom ${sortDataRef.current[value.id].sort === "asc" ? "selected" : ""}`} />

              :
              selectedSortRef.current === value.id && value.id !== "LicenseDocument" && selectedSortRef.current === "Value" ?
                sortDataRef.current[value.id].sort === "asc" ?
                  <ArrowDropUpRoundedIcon className={`sort-data top ${sortDataRef.current[value.id].sort === "desc" ? "selected" : ""}`} />
                  :
                  <ArrowDropDownRoundedIcon className={`sort-data bottom ${sortDataRef.current[value.id].sort === "asc" ? "selected" : ""}`} />

                : ""
            }
          </div>
        </div>
      )
    })
    /* eslint-enable array-callback-return*/

    return (<div className="audience-table-header">{list}</div>)
  }

  const getTableBody = () => {
    var list = [];

    let doseFormat = selectedDoseFormatRef.current;

    /* eslint-disable */
    let dataPrescribers = prescribersDataRef.current.filter(item => item.LicenseDose ? item.LicenseDose.toLowerCase() === doseFormat.toLowerCase() : null);

    if (doseFormat === "Herb Dried, Vaporisation") {
      dataPrescribers = prescribersDataRef.current.filter(item => item.LicenseDose === "Herb Dried, Vaporised" || item.LicenseDose === "Herb, dried (for vaporisation)" || item.LicenseDose === doseFormat);
    }
    /* eslint-enable */

    if (dataPrescribers.length === 0) {
      list.push(<div className="list no-data" key="none">No data available</div>)
    } else {
      /* eslint-disable array-callback-return*/
      dataPrescribers.map((value, index) => {
        let category = "-";

        // if(value.ProductCategory.replace("Category ", ""))
        if (value.ProductCategory) {
          category = value.ProductCategory.match(/\d/g).join("");
        }

        let expiryDate = moment(value.NoticeDate, "DD-MM-YYYY").format("DD-MMM-YYYY");
        const todayDate = moment();

        let status = "";

        var dDiff = todayDate.diff(expiryDate);
        if (dDiff > 0) {
          status = "Expired";
        } else {
          status = "Valid";
        }

        const isSasBApprovals = selectedDoseFormatRef.current === "SAS-B Approvals";

        list.push(
          <>
            {index !== 0 ?
              <div className="divider-prescribers-mobile hide-desktop"></div>
              : ""}
            <div key={index}>
              <div key={index} className="list" style={{ "background": "#FFFFFF" }}>
                {isSasBApprovals ?
                  <div className="child" style={{ "--width": headerData[0].width_table + "%" }}>
                    <div className="text">{value.PatientInitials}</div>
                  </div>
                  : ""}
                <div className="child" style={{ "--width": headerData[isSasBApprovals ? 1 : 0].width_table + "%" }}>
                  <div className="text">{category}</div>
                </div>
                <div className="child" style={{ "--width": headerData[isSasBApprovals ? 2 : 1].width_table + "%" }}>
                  <div className="text" style={{ color: status === "Expired" ? "#FF0000" : "#262626" }}>{status}</div>
                </div>
                <div className="child" style={{ "--width": headerData[isSasBApprovals ? 3 : 2].width_table + "%" }}>
                  <div className="text">{expiryDate}</div>
                </div>
                <div className="child" style={{ "--width": headerData[isSasBApprovals ? 4 : 3].width_table + "%" }}>
                  <div className="text">{value.TGAApprovalNumber}</div>
                </div>
                <div className="child" style={{ "--width": headerData[isSasBApprovals ? 5 : 4].width_table + "%" }} onClick={() => window.open(value.SharepointURL)}>
                  <span className="text view" >View</span>
                </div>
              </div>
            </div>
          </>
        )
      })
      /* eslint-enable array-callback-return*/
    }

    return (<div className="audience-table-body" style={{ paddingBottom: "48px" }}>
      {list}</div>)
  }

  return (
    <div className="custom-popup-container-wrapper" style={{ height: "100%" }}>
      <div>
        <div className="custom-popup-container-wrapper-header">
          <div>Registered TGA Approvals</div>
          <div className="hide-mobile"><CloseIcon className="close-popup-icon" onClick={() => onClosePopup()} /></div>
        </div>
        {loadingRef.current ?
          <LoadingView /> :
          <div className="custom-popup-container-wrapper-body">
            <div className="registerd-tga-approvals-header">
              Prescriber: <span className="value">{props.customData.DoctorName}</span>
            </div>
            <div style={{ marginTop: "16px" }}>
              <FormControl w="100%" maxW="100%">
                <div className={`select-input-container-2`}
                  style={{ "--width": "250px", color: "#333333" }}
                  onClick={(e) => { clickMenu(e) }}>
                  <div className="text">{selectedDoseFormatRef.current}</div>
                  <ArrowDropDownIcon className="select-input-dropdown-icon" />
                </div>
                <Menu
                  className={`${classes.select_menu} ${classes.select_menu_sort}`}
                  id="select_menu_desktop"
                  anchorEl={anchorSelectMenuDoseFormat}
                  getContentAnchorEl={null}
                  keepMounted
                  open={openSelectMenuDoseFormat}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  onClose={() => closeMenu("sort_by")}
                  style={{ maxHeight: "400px", maxWidth: "450px" }}
                  disableAutoFocus
                  disableAutoFocusItem
                >

                  {optionsDoseFormatRef.current.map((value, index) => (
                    <MenuItem
                      autoFocus={false} key={index} onClick={() => {
                        onClickSelectedDoseFormat(value.Name)
                      }}>
                      <div className={`select-menu-list-desktop ${selectedDoseFormatRef.current === value.Name ? "selected" : ""}`}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div className="text">{value.Name}</div>
                        </div>
                      </div>
                    </MenuItem>
                  ))}
                </Menu>
              </FormControl>
            </div>
            {selectedDoseFormatRef.current === "Dose Format" ? "" :
              <>
                <div className="audience-content-table-container">
                  <div className="audience-content-table" style={{ marginTop: "16px", marginBottom: "16px" }}>
                    {getTableHeader()}
                    {getTableBody()}
                  </div>
                </div>
                <div className="prescribers-detail-note">
                  <HelpOutlineIcon style={{ marginRight: "5px", marginLeft: "-9px", fontSize: "16px", marginTop: "1px" }} />
                  Note: To update a doctor’s TGA approvals, please place a new order and upload the approval document.
                </div>
              </>
            }
          </div>
        }
      </div>
      <div className="custom-popup-container-wrapper-bottom">
        {selectedDoseFormatRef.current === "SAS-B Approvals" ?
          <button className={`custom-popup-button-green ${productListRef.current.length === 0 ? "disabled" : ""}`} onClick={() => onSubmit()}>Submit</button>
          : <div style={{ minHeight: "35px" }}></div>}
      </div>
    </div >
  );
}

export default RegisteredTGAApprovalsView;